export { addInstanceToTypeIndex } from "./addInstanceToTypeIndex.js";
//# sourceMappingURL=index.js.map